// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3pFWo","ranges":"BmiRanges_ranges__1jGuS"};